import { css, styled } from "../../../styled-components";
import Img from "../img/img";

const cardStyleCSS = css`
    margin: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;
    border-radius: 12px;
    overflow: hidden;
`;

export const Wrapper = styled.div<{ cardStyle?: boolean }>`
    position: relative;

    ${p => p.cardStyle && cardStyleCSS}

    height: ${p => p.theme.summary.height}px;
    background-color: ${p => p.theme.skeletonColor};

    &.threeby1 {
        height: unset;
        padding-bottom: 33%;
    }

    &.threeby2 {
        height: unset;
        padding-bottom: 67%;
    }

    .title-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
`;

export const Skeleton = styled.div`
    height: ${p => p.theme.summary.height}px;
    background-color: ${p => p.theme.skeletonColor};
`;

export const ImageStyle = styled(Img)`
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const Image = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: hidden;

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const ImageSummaryViewDetailsStyle = styled.div`
    color: white;
    text-shadow: 0 0px 4px rgba(0, 0, 0, 0.5);
    padding: ${p => p.theme.pageMarginMedium}px;
    background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.9));

    margin-bottom: -1px;
`;

export const TitleViewTitleStyle = styled.div`
    ${p => p.theme.summary.title.fontStyle};
`;

export const TitleViewSubtitleStyle = styled.div`
    ${p => p.theme.summary.detail.fontStyle};
`;
